
































































import Reflect from "reflect-metadata";
import { Component, Vue, Prop } from "vue-property-decorator";
import { User } from "@/models/User";
import { SecurityPayload } from "@/services/UserService";

@Component
export default class UserSecurity extends Vue {
  @Prop({ default: {} })
  security!: Partial<SecurityPayload>;

  /**
   * Validation rules for inputs
   */
  rules = {
    required: (value: string) => !!value || "El campo es requerido",
    max: (value: string) =>
      (value && value.length <= 50) || "Máximo 50 caracteres",
    min: (value: string) =>
      (value && value.length >= 8) || "Mínimo 8 caracteres",
    match: (value: string) =>
      (value && value == this.security.password) ||
      "Las contraseñas no coinciden"
  };

  extra = {
    passwordConfirmation: undefined,
    showPassword: true,
    showConfirmation: false
  };

  /**
   * Called when security type changes (auto or manual)
   */
  handleSecurityChange = (value: boolean) => {
    this.extra.passwordConfirmation = undefined;
    if (value) {
      this.extra.showPassword = true;
    } else {
      this.extra.showPassword = false;
      this.extra.showConfirmation = false;
    }
    this.$root.$emit(
      "update:password",
      value
        ? Math.random()
            .toString(36)
            .slice(2)
        : undefined
    );
  };
}
